import { createBrowserRouter, Navigate, Outlet, useLocation, type RouteObject } from 'react-router';
import { AppShell } from './AppShell';
import { useSession } from './session';
import { LoginPage } from '@/features/auth/LoginPage';
import { operationsRoutes } from './routes.operations';
import { adminRoutes } from './routes.admin';
import { LoadingState } from '@/components/ui';
import { PreparingPage } from '@/features/setup/SetupNotice';
import { setupGate } from './setup-gate';

function RequireAuth() {
  const { me, loading, admin } = useSession();
  const { pathname, search } = useLocation();
  if (loading) return <div className="p-8"><LoadingState rows={4} /></div>;
  // Sin sesión, al ingreso de la suite recordando la ruta pedida: un enlace profundo termina en el enlace.
  if (!me) return <Navigate to={`/login${pathname !== '/' ? `?volver=${encodeURIComponent(pathname + search)}` : ''}`} replace />;
  const gate = setupGate(me, admin, pathname);
  // La puesta en marcha es solo del Administrador: los demás ven toda la vista en preparación, sin menú.
  if (gate === 'preparing') return <div className="min-h-svh grid place-items-center bg-background p-6"><PreparingPage /></div>;
  if (gate !== 'app') return <Navigate to={gate.redirect} replace />;
  return <AppShell />;
}

function NotFound() {
  return <div className="p-8 text-muted-foreground">Esta página no existe. <a href="/" className="text-primary underline underline-offset-4">Volver al inicio</a></div>;
}

/**
 * Route registry. Feature areas register their routes in:
 *  - routes.operations.tsx → dashboard, solicitudes inbox, expediente, tasks, queues, citizens, profile
 *  - routes.admin.tsx      → configuration (workflows designer, users, teams, SLA, engines…), reports
 * Keep this file stable; add screens in those two files.
 */
const children: RouteObject[] = [...operationsRoutes, ...adminRoutes, { path: '*', element: <NotFound /> }];

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/', element: <RequireAuth />, children },
  { path: '*', element: <Outlet /> },
]);
